<lib-tour-view [id]="id"></lib-tour-view>